module.exports = __webpack_public_path__ + "static/media/zipdj-default-thumb-300x300.a220298b.svg";